module.exports = __webpack_public_path__ + "static/img/zhuanli.507f4093.png";